import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const reclaimCohortRowSchema = z.object({
  weekStart: z.coerce.date(),
  total: z.number().int(),
  resolved: z.number().int(),
  won: z.number().int(),
  lost: z.number().int(),
  wonExcludingProtected: z.number().int(),
  lostExcludingProtected: z.number().int(),
});

export interface ReclaimCohortRow extends z.infer<
  typeof reclaimCohortRowSchema
> {}

export const getReclaimMatureCohorts = unaryRpc({
  name: "getReclaimMatureCohorts" as const,
  input: z.object({
    minMaturityDays: z.number().int().min(1).max(365).optional(),
    weeksBack: z.number().int().min(1).max(52).optional(),
  }),
  output: z.object({
    cohorts: z.array(reclaimCohortRowSchema),
    minMaturityDays: z.number().int(),
  }),
});
